import script from "./MGWalletStack.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGWalletStack.vue?vue&type=script&setup=true&lang=ts"

import "./MGWalletStack.vue?vue&type=style&index=0&id=9c3ecb68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c3ecb68"]])

export default __exports__